import { IApplicationState } from '../../../../../../../types/types';
import { TTabKey } from '../../types';

export const getBoardsIsLoading = (
    state: IApplicationState,
    tabKey: TTabKey
): boolean => {
    return state.openBoardsDialog && state.openBoardsDialog.boards &&  state.openBoardsDialog.boards.isLoading[tabKey];
}
